import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';

interface SaveProfileDialogProps {
  open: boolean;
  existingNames: string[];
  onSave: (name: string) => void;
  onClose: () => void;
}

export const SaveProfileDialog = ({
  open,
  existingNames,
  onSave,
  onClose,
}: SaveProfileDialogProps) => {
  const [name, setName] = useState('');

  const trimmed = name.trim();
  const isDuplicate = existingNames.some(
    (existing) => existing.toLowerCase() === trimmed.toLowerCase(),
  );

  let error: string | null = null;

  if (trimmed === '') {
    error = 'Profile name is required';
  } else if (isDuplicate) {
    error = 'You already have a profile with this name';
  }

  const handleSave = () => {
    if (error) {
      return;
    }
    onSave(trimmed);
    setName('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        <Typography>Save current as profile</Typography>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          size="small"
          margin="dense"
          label="Profile name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          error={name !== '' && error !== null}
          helperText={name !== '' ? error : undefined}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              handleSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          disabled={error !== null}
          onClick={handleSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
